export default __webpack_public_path__ + "static/media/EI3-2.3ca32cee.jpg";